import type { AnswerT } from '..';
import type { ImageQAEngine, QAAnnotationLabelAnswersInput } from './type/qa-engine';
import type { ImageResolver } from './type/resolver';
import type { Rule } from './type/rule';
import { QaCheckError } from './utils/error';
import { getFetchedDataForRule } from './utils/image/fetch-data-for-rule';
import { createQaEngine } from './qa-engine';
export const createImageQAEngine = (rules: Rule<ImageResolver>[]): ImageQAEngine => {
  const {
    evaluateRuleOnTaskState: evaluateRuleOnTaskStateBase
  } = createQaEngine(rules, getFetchedDataForRule);
  const evaluateRuleOnTaskState = (args: {
    annotationLabelAnswers: QAAnnotationLabelAnswersInput[];
    taskQuestionnaire: AnswerT;
  }) => {
    const {
      annotationLabelAnswers,
      taskQuestionnaire
    } = args;
    const result = evaluateRuleOnTaskStateBase({
      annotationLabelAnswers,
      taskQuestionnaire
    });
    if (result instanceof QaCheckError) {
      return result;
    }
    return result;
  };
  return {
    evaluateRuleOnTaskState
  };
};